// Display labels for the ten risk signals.
//
// THE INVARIANT (the same one PILLAR_LABEL keeps): the KEY is the BE's, the
// LABEL is ours. The keys below are exactly
// `insights/services/signals/vocabulary.py::ALL_SIGNALS`, which is a hard
// contract — `risk_prediction_service.CANONICAL_FEATURES` is the column order
// the gradient-boosting model was trained on, so a signal is never renamed at
// the source just to read better in a table. It is labelled here instead.
//
// WHICH LANGUAGE: not the UI locale. These name what the report FOUND, so they
// follow the report's own language — `SurveyInsight.language`, served as
// `language` on the report-detail response. A Spanish report read by someone
// whose app is in English still shows Spanish signal names, because the rest of
// that report (topics, prose, quick actions) is Spanish too.
const SIGNAL_LABELS = {
    en: {
        // Negative
        strain: "Strain",
        distrust: "Distrust",
        disconnection: "Disconnection",
        resistance: "Resistance",
        confusion: "Confusion",
        // Positive
        energy: "Energy",
        trust: "Trust",
        connection: "Connection",
        optimism: "Optimism",
        clarity: "Clarity",
    },
    es: {
        // Negative
        strain: "Tensión",
        distrust: "Desconfianza",
        disconnection: "Desconexión",
        resistance: "Resistencia",
        confusion: "Confusión",
        // Positive
        energy: "Energía",
        trust: "Confianza",
        connection: "Conexión",
        optimism: "Optimismo",
        clarity: "Claridad",
    },
};

// 'es' / 'es-MX' / 'Spanish' -> 'es'; anything else (including empty) -> 'en'.
// Mirrors the BE's normalize_report_language, so a legacy row that stored a
// locale rather than a bare code still lands on the right labels.
export const normalizeReportLanguage = (value) => {
    const key = String(value || "").trim().toLowerCase();
    if (key === "es" || key.startsWith("es-") || key === "spanish") return "es";
    return "en";
};

// Label for one signal. An unknown key falls back to the key itself rather than
// rendering blank: if the BE ever adds an eleventh signal, the table shows its
// raw name (as it does today) until it is labelled here.
export const signalLabel = (signalName, language) => {
    const table = SIGNAL_LABELS[normalizeReportLanguage(language)] || SIGNAL_LABELS.en;
    return table[signalName] || SIGNAL_LABELS.en[signalName] || signalName;
};

export default SIGNAL_LABELS;
